import React, { Component } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./../../wrapper";
import { logInUserInfo } from "../../Actions/Users";
import axios from "axios";
import { ServiceItemsList } from "../../Components/ServiceMissingItems";
import withRoutes from "../../HOC/HocRoutes";

let source;
class ServiceMissingItems extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userInfo: {},
      to: "",
      from: "",
      selectedUser: "",
      expenseType: "",
      accType: "",
      page: 1,
      pageSize: 20,
      searchItem: "",
      value: "maintenance",
      invoiceData: "",
      searchInvoiceText: "",
      selectedAccount: "",
      selectSingleInvoice: false,
      itemsData: "",
      leasing: false,
      showPayments: false,
      recievingPartyAccounts: [],
      contractType: 1,
      loader1: false,
      loader2: false,
      selectSingleAccount: false,
      itemsData: [],
      checkUser: true,
    };
  }
  componentDidMount() {
    this.getMissingItems();
    this.getContractsData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.logInUser &&
      this.state.checkUser &&
      prevProps.logInUser?.id !== this.props.logInUser?.id
    ) {
      this.getContractsData();
    }
  }

  searchInvoiceText = (e) => {
    source.cancel();
    this.setState(
      {
        searchInvoiceText: e.target.value,
      },
      () => {
        this.getContractsData();
      }
    );
  };

  setPagination = () => {
    let nAcc = { ...this.state.itemsData };
    let lastPage = nAcc.total / this.state.pageSize;
    let IsFloate = this.checkFloteNumber(lastPage);
    delete nAcc.data;
    nAcc.pageSize = this.state.pageSize;
    nAcc.lastPage = IsFloate ? parseInt(lastPage + 1) : lastPage;
    return nAcc;
  };

  checkFloteNumber(n) {
    return Number(n) === n && n % 1 !== 0;
  }

  handleChangePage = (value) => {
    this.setState(
      {
        to: this.state.to,
        from: this.state.from,
        selectedUser: this.state.selectedUser,
        expenseType: this.state.expenseType,
        accType: this.state.accType,
        page: value,
      },
      () => this.getMissingItems()
    );
  };

  handleChangeRowsPerPage = (value) => {
    this.setState(
      {
        to: this.state.to,
        from: this.state.from,
        selectedUser: this.state.selectedUser,
        expenseType: this.state.expenseType,
        accType: this.state.accType,
        pageSize: value,
        page: 1,
      },
      () => this.getMissingItems()
    );
  };

  handleChangeTabs = (e) => {
    if (e === "leasing") {
      this.setState(
        {
          value: e,
          leasing: true,
          contractType: 2,
        },
        () => {
          this.getContractsData();
        }
      );
    } else if (e === "maintenance") {
      this.setState(
        {
          value: e,
          leasing: false,
          contractType: 1,
        },
        () => {
          this.getContractsData();
        }
      );
    }
  };

  getContractsData = () => {
    if (!this.props.logInUser?.id) return;
    let list = {};
    let usersId = {};

    let apiUrl = `/api/accounts/list?all=true&contractType=1&userId=${this.props.logInUser.id}&limit=-1&search=${this.state.searchInvoiceText}`;
    source = axios.CancelToken.source();
    this.setState(
      {
        accounts: [],
        loader1: false,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            let dataRes = response?.data?.data?.data || [];
            dataRes &&
              dataRes.map(
                (d) => ((list[d.contractNumber] = true), (usersId[d.userId] = true))
              );
            this.setState({
              accounts: response?.data?.data || {},
              makingAccounts: list,
              makingUsers: usersId,
              loader1: false,
              checkUser: false,
            });
          })
          .catch((e) => {
            console.log("e ===", e);
          });
      }
    );
  };

  invoiceSelection = (item) => {
    this.setState(
      {
        selectedAccount: item,
        selectSingleAccount: true,
      },
      () => {
        this.getMissingItems(item.contractNumber);
      }
    );
  };

  goBack = () => {
    this.setState(
      {
        selectSingleAccount: false,
      },
      () => {
        this.getContractsData();
      }
    );
  };

  getItems = (userId, to, from, expenseType, accType) => {
    this.setState(
      {
        to: to,
        from: from,
        selectedUser: userId,
        expenseType: expenseType,
        accType: accType,
      },
      () => {
        this.getMissingItems();
      }
    );
  };

  getMissingItems = () => {
    let dateto = this.state.to || "";
    let datefrom = this.state.from || "";
    let userId = this.state.selectedUser || "";
    let name = this.state.expenseType || "";
    let contract =
      this.state.accType === "cash"
        ? 3
        : this.state.accType === "maintenance"
        ? 1
        : null;
    let { page, pageSize, searchItem } = this.state;
    let apiUrl = `/api/services/items/notincontract?page=${page}&limit=${pageSize}&itemCode=${searchItem}`;

    if (dateto) apiUrl += `&to=${dateto}`;
    if (datefrom) apiUrl += `&from=${datefrom}`;
    if (userId) apiUrl += `&contractNumber=${userId}`;
    if (name) apiUrl += `&name=${name}`;
    if (contract) apiUrl += `&contractType=${contract}`;

    source = axios.CancelToken.source();
    this.setState(
      {
        loader2: true,
      },
      () => {
        axios
          .get(apiUrl, {
            cancelToken: source.token,
          })
          .then((response) => {
            this.setState({
              loader2: false,
              itemsData: response?.data?.data || [],
            });
          })
          .catch((e) => {});
      }
    );
  };

  searchItems = (e) => {
    source.cancel();
    this.setState(
      {
        to: this.state.to,
        from: this.state.from,
        selectedUser: this.state.selectedUser,
        expenseType: this.state.expenseType,
        accType: this.state.accType,
        searchItem: e.target.value,
      },
      () => {
        this.getMissingItems();
      }
    );
  };

  render() {
    if (this.props.logInUser) {
      return (
        <Layout
          {...this.state}
          {...this.props}
          getMissingItems={this.getItems}
        >
          <ServiceItemsList
            {...this.state}
            getMissingItems={this.getMissingItems}
            {...this.props}
            searchItems={this.searchItems}
            itemsData={this.state.itemsData.data || []}
            setPagination={this.setPagination}
            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
            handleChangePage={this.handleChangePage}
            goBack={this.goBack}
            translate={this.props.translate}
          />
        </Layout>
      );
    } else {
      fetch("/api/session?app=3b8d4deb84c0d9b65070c872e2f73626f23d8dc8789a7a05", {
        headers: { Accept: "application/json; odata=verbose" },
      })
        .then((response) => {
          if (response.ok) {
            response.json().then((res) => {
              if (res.status === "success") {
                let userInfo = res.data;
                this.props.setActiveLanguage(userInfo?.attributes?.lang || "en");
                this.props.dispatch(logInUserInfo(userInfo));
              } else if (res?.statusCode === "440") {
                window.location.replace("/login");
              } else if (res.statusCode) {
                var err = res?.message.split(":");
                err[1] = err[1].replace(")", "");

                toast.error(this.props.translate(err[1]));
                this.props.navigate("/login");
              }
            });
          } else {
            this.props.navigate("/login");
            throw response;
          }
        })
        .catch((e) => {
          this.props.navigate("/login");

          toast.error("somethingWentWrong");
        });
      return null;
    }
  }
}

const mapStateToProps = (state) => ({
  ServerSetting: state.ServerSetting,
  logInUser: state.logInUsers,
});

export default connect(mapStateToProps)(withRoutes(ServiceMissingItems));
